import AsoHeader from '../../../components/Aso/Header';
import TermosCondicoes from '../../../components/Aso/Register/TermosCondicoes';

export function AsoTermosCondicoes() {

  return (
    <div>
      <AsoHeader />
      < TermosCondicoes />
    </div>
  );
}
